import { render } from "./PlayerScore.vue?vue&type=template&id=262ff093&scoped=true"
import script from "./PlayerScore.vue?vue&type=script&lang=js"
export * from "./PlayerScore.vue?vue&type=script&lang=js"

import "./PlayerScore.vue?vue&type=style&index=0&id=262ff093&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262ff093"]])

export default __exports__